<template>
    <div :class="hasLabels ? 'mt-1' : ''" class="flex rounded">
        <div
            id="input"
            :class="input ? 'bg-gray-600' : 'bg-gray-200'"
            aria-checked="false"
            class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:shadow-outline-blue"
            role="checkbox"
            tabindex="0"
            @click="check"
        >
            <div
                :class="input ? 'translate-x-5' : 'translate-x-0'"
                aria-hidden="true"
                class="inline-block h-5 w-5 rounded-full bg-white shadow transform transition ease-in-out duration-200"
            ></div>
        </div>
        <div v-if="hasLabels" class="ml-3 text-sm text-gray-600">
            <small v-if="input">{{ enabledLabel }}</small>
            <small v-else>{{ disabledLabel }}</small>
        </div>
    </div>
</template>

<script>
export default {
    name: "input-switch",
    emits: ['input', 'update:modelValue'],
    props: {
        modelValue: {
            required: false,
            default: undefined,
        },
        value: {
            required: false
        },
        id: {
            type: String,
            required: true
        },
        readonly: {
            type: Boolean,
            default: false
        },
        enabledLabel: {
            type: String,
            required: false,
            default: ''
        },
        disabledLabel: {
            type: String,
            required: false,
            default: ''
        },
    },
    computed: {
        hasLabels() {
            return !!this.enabledLabel || !!this.disabledLabel;
        },
        input: {
            get() {
                return this.modelValue !== undefined ? this.modelValue : this.value;
            },
            set(value) {
                this.$emit('update:modelValue', value);
                this.$emit('input', value);
            }
        }
    },
    methods: {
        check() {
            if (!this.readonly) {
                this.input = !this.input;
            }
        }
    }
}
</script>
